// This is a dumb name, how to migrate
export const HashKeyMarkdownLegacy = "base64";
export const HashKeyMarkdown = "md";
export const HashKeyUrl = "url";